import { useMemo, useContext } from 'react';
import { ChatPermissionsContext } from '../context';

export function useChatPermissions() {
  const ctx = useContext(ChatPermissionsContext);
  return useMemo(() => ({
    canModify: false,
    ...ctx,
  }), [ctx]);
}